import { Text, View } from "@react-pdf/renderer";
import sharedStyles from "./PdfStyles";
import { formate } from "./utiil/Formate";

const PdfUser = ({ user, lastDay }) => {

    const entries = [];
    for (let d = 1; d <= lastDay; d++) {
        entries.push(user.entries[d] ? formate(user.entries[d].hours) : '-');
    }

    return (
        <View style={sharedStyles.tableRow}>
            <View style={sharedStyles.name_cell}>
                <Text style={sharedStyles.name_text}>{user.name}</Text>
            </View>
            {entries.map((val, i) => (
                <View key={i} style={sharedStyles.hours_cell}>
                    <Text style={sharedStyles.hours_text}>{val}</Text>
                </View>
            ))}
            <View style={sharedStyles.sum_cell}>
                <Text style={sharedStyles.sum_text}>{formate(user.sum_hours)}</Text>
            </View>
        </View>
    );
};

export default PdfUser;
